import { render } from "./schoolMain.vue?vue&type=template&id=13573d9c&scoped=true"
import script from "./schoolMain.vue?vue&type=script&lang=js"
export * from "./schoolMain.vue?vue&type=script&lang=js"

import "./schoolMain.vue?vue&type=style&index=0&id=13573d9c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13573d9c"]])

export default __exports__